import { useMemo } from "react";
import { useAuth } from "@/core/auth";
import { useEnv } from "@/core/env";
import { createApiInstance } from "./createApiInstance";

const useApi = () => {
  const { apiUrl } = useEnv();
  const { refreshToken } = useAuth();

  return useMemo(
    () =>
      createApiInstance(apiUrl, {
        onRefreshToken: refreshToken,
      }),
    [apiUrl, refreshToken],
  );
};

export default useApi;
